export default __webpack_public_path__ + "static/media/devanture_3_1.540788b6.png";